// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__CkX3U","header":"PatientBlock_header__JNkTa","label":"PatientBlock_label__2WhZf","option":"PatientBlock_option__3tNAW"};